import {
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    getAllLotteryBrandDay,
    getAllLotteryBrandDaysCode,
} from '../../../redux/features/lotteryBrandDay/lotteryBrandDayService';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Modal from '../../../components/Modal';
import { showToast } from '../../../components/ToastMsg';
import { editLotteryInfo, getLotteries } from '../../../redux/features/lottery/lotteryService';
import Pagination from '../../../components/Pagination';
import { getWinnersList, publishWinnerInfo } from '../../../redux/features/winners/winnersService';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const WinnersList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isWinnersLoading, pageCount, winners } = useSelector((state) => state.winner.winnersList);

    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedLotteryId, setSelectedLotteryId] = useState(null);
    const [selectedLotteryName, setSelectedLotteryName] = useState('');
    const [reload, setReload] = useState(false);
    const [drawDate, setDrawDate] = useState(null);
    const [brand, setBrand] = useState(null);
    const [drawNo, setDrawNo] = useState(null);
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const closeDeactivationModal = () => setDeactivationModalOpen(false);

    const fetchAllWinners = useCallback(
        (filters = {}) => {
            const params = {
                draw_date: drawDate && drawDate,
                draw_no: drawNo,
                lottery_brand_day_id: brand?.id,
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(getWinnersList(params));
        },
        [dispatch, drawDate, drawNo, brand, skip]
    );

    useEffect(() => {
        fetchAllWinners();
    }, [fetchAllWinners]);

    useEffect(() => {
        dispatch(getAllLotteryBrandDay({ status: true }));
    }, [dispatch, reload]);

    const handlePublish = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(
                publishWinnerInfo({ ticket_id: selectedLotteryId, is_winner_published: true })
            ).unwrap();
            setSelectedLotteryId(null);
            showToast('success', response.message);
            fetchAllWinners();
            setReload((prev) => !prev);
        } catch (error) {
            showToast('error', error.message);
        }
    };

    const handleEditLotteryDays = (lottery) => {
        navigate(`${lottery.lottery_brand_day.id}`, { state: {name: lottery.lottery_brand_day.name, draw_date: lottery.draw_date,  draw_no: lottery.draw_no, count: lottery.count} });
    };

    useEffect(() => {
        dispatch(getAllLotteryBrandDaysCode({ id: brand }));
    }, [dispatch, brand, reload]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Winners{' '}
                    </h1>
                </div>
                <div className={`form-input-col`}>
                    <div className={`form-input-group`}>
                        <input
                            type="date"
                            value={drawDate || ''}
                            onChange={(e) => setDrawDate(e.target.value)}
                            className={`form-input-default`}
                            placeholder="Draw Date"
                        />
                    </div>
                </div>
            </div>

            <div>
                {isWinnersLoading ? (
                    <TableSkeleton
                        columns={['Image', 'Code', 'Name', 'Brand', 'Actions']}
                        rowCount={10}
                        height={20}
                    />
                ) : winners.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Code</th>
                                    <th>Name</th>
                                    <th>Draw No</th>
                                    <th>Username</th>
                                    <th>Phone Number</th>
                                    <th>Status</th>
                                    <th className={styles.priceTd}>Price</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {winners?.map((lottery) => (
                                    <tr key={lottery.id}>
                                        <td className={`tdataColumnOne`}>{lottery?.code}</td>
                                        <td>{lottery?.lottery.lottery_brand_day.name}</td>
                                        <td className={styles.smTd}> {lottery?.lottery.draw_no} </td>
                                        <td className={styles.smTd}>{lottery?.user.username}</td>
                                        <td>{lottery?.user.phone_number}</td>
                                        <td className={styles.smTd}>{lottery?.is_winner_published ? 'Publish' : 'Pending'}</td>
                                        <td className={styles.priceTd}>Rs. {lottery?.winning_price}</td>
                                        <td className={`actionsBtn`}>
                                            {!lottery?.is_winner_published &&
                                                <button className={`btn-primary`} onClick={() => {
                                                    setSelectedLotteryId(lottery.id);
                                                    setDeactivationModalOpen(true);
                                                }}
                                                style={{backgroundColor: 'var(--green)', borderColor: 'var(--green)'}}>
                                                    Publish
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`} style={{marginTop: '20px'}}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>

            {isDeactivationModalOpen && (
                <Modal
                    title='Publish Winner'
                    onClose={closeDeactivationModal}
                    onYes={handlePublish}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={
                        <>
                            Are you sure you want to publish the winner?
                            <br />
                            <b>{selectedLotteryName}</b>
                        </>
                    }
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};

export default WinnersList;
